import {RESET_REGISTRATION_STEP,
  REGISTER_FLOW_USER_REQUEST,
  REGISTER_FLOW_USER_SUCCESS,
  REGISTER_FLOW_USER_FAILED,
  REGISTER_FLOW_CONTACT_REQUEST,
  REGISTER_FLOW_CONTACT_SUCCESS,
  REGISTER_FLOW_CONTACT_FAILED,
  REGISTER_FLOW_SUBSCRIPTIONS_REQUEST,
  REGISTER_FLOW_SUBSCRIPTIONS_SUCCESS,
  REGISTER_FLOW_SUBSCRIPTIONS_FAILED,
  REGISTER_FLOW_FINAL_REQUEST,
  REGISTER_FLOW_FINAL_SUCCESS,
  REGISTER_FLOW_FINAL_FAILED} from '../../actions/register-flow/register-flow'

import {LOGIN_SUCCESS} from '../../actions/loginActions'

const initialState = {

  // register data
  username: '',
  email: '',
  password: '',
  passwordRepeat: '',
  moduleOptions: [],

  // step 1 data
  profilePicture: null,
  phone: '',

  // step 2 data
  subscriptions: null,

  // step 3 data
  companyName: '',
  cui: '',
  accountNumber: '',
  contactName: '',
  contactPhone: '',
  contactEmail: '',

  // register flow
  error: null,
  completed: false,
  registering: false,
}

export const registerFlow = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS: {
      return initialState
    }
    case REGISTER_FLOW_USER_REQUEST: {
      return Object.assign({}, state, {
        step1: null,
        error: null,
        registering: true
      })
    }
    case REGISTER_FLOW_CONTACT_REQUEST: {
      return Object.assign({}, state, {
        step2: null,
        error: null,
        registering: true
      })
    }
    case REGISTER_FLOW_SUBSCRIPTIONS_REQUEST: {
      return Object.assign({}, state, {
        step3: null,
        error: null,
        registering: true
      })
    }
    case REGISTER_FLOW_FINAL_REQUEST: {
      return Object.assign({}, state, {
        step4: null,
        completed: false,
        error: null,
        registering: true
      })
    }
    case RESET_REGISTRATION_STEP: {
      const { step } = action
      return {
 ...state, [`step${  step}`]: null, completed: false, error: null, registering: false
 }
    }
    case REGISTER_FLOW_USER_SUCCESS: {

      const { email, password, passwordRepeat, username, moduleOptions } = action.payload
      return Object.assign({}, state, {
        step1: {
          username,
          email,
          password,
          passwordRepeat,
          moduleOptions,
        },
        username,
        email,
        password,
        passwordRepeat,
        moduleOptions,
        error: null,
        registering: false
      })
    }
    case REGISTER_FLOW_USER_FAILED: {
      const { email, password, passwordRepeat, username, moduleOptions } = action.payload
      return Object.assign({}, state, {
        email,
password,
passwordRepeat,
username,
moduleOptions,
        step1: null,
        error: action.error,
        registering: false
      })
    }

    case REGISTER_FLOW_CONTACT_SUCCESS: {
      const { phone, profilePicture } = action.payload
      return Object.assign({}, state, {
        step2: {
          phone,
          profilePicture,
        },
        phone,
        profilePicture,
        error: null,
        registering: false
      })
    }
    case REGISTER_FLOW_CONTACT_FAILED: {
      const { phone, profilePicture } = action.payload
      return Object.assign({}, state, {
        phone,
        profilePicture,
        step2: null,
        error: action.error,
        registering: false
      })
    }
    case REGISTER_FLOW_SUBSCRIPTIONS_SUCCESS:
      const { subscriptions } = action.payload
      return Object.assign({}, state, {
        step3: {
 subscriptions 
},
        subscriptions,
        error: null,
        registering: false
      })

    case REGISTER_FLOW_SUBSCRIPTIONS_FAILED: {
      const { subscriptions } = action.payload
      return Object.assign({}, state, {
        subscriptions,
        error: action.error,
        registering: false
      })
    }

    case REGISTER_FLOW_FINAL_SUCCESS: {
      const { step4 } = action.payload
      return Object.assign({}, state, {
        completed: true,
        step4,
        error: null,
        registering: false
      })
    }
    case REGISTER_FLOW_FINAL_FAILED: {
      const { step4 } = action.payload
      return Object.assign({}, state, {
        completed: false,
        step4,
        error: action.error,
        registering: false
      })
    }
    default:
      return state
  }

}



// WEBPACK FOOTER //
// ./src/redux/reducers/register-flow/register-flow.js